import { builder } from '../../../../../common/js/configs';

export const brandPriorityOverArrow = {
  brandOrArrowPriority: builder.string('brand_priority_over_arrow', {
    possibleValues: [
      {
        name: 'Arrow over Brand',
        value: 'arrowOverBrand'
      },
      {
        name: 'Brand over Arrow',
        value: 'brandOverArrow'
      }
    ],
    defaultValue: 'brandOverArrow'
  })
};

export const arrowPriorityOverBrand = {
  brandOrArrowPriority: builder.string('brand_priority_over_arrow', {
    possibleValues: [
      {
        name: 'Arrow over Brand',
        value: 'arrowOverBrand'
      },
      {
        name: 'Brand over Arrow',
        value: 'brandOverArrow'
      }
    ],
    defaultValue: 'arrowOverBrand'
  })
};
